import { type FC } from "react";
import _ from "lodash";
import { Box, Dialog, Stack, Typography, TextField } from "@mui/material";
import { ContainButtonShort, LinearTextDialog, OutlineButtonShort } from "../../utils";
import IconAccountActive from "../../assets/images/icons/active/active-icon-issuer.png";
import "../dialogAddWalletAddress/DialogAddWalletAddress.css";

interface DialogAddWalletAddressProps {
    open: any;
    value: string;
    title?: string;
    subTitle?: string;
    confirm: () => void;
    description?: string;
    address?: string;
    onClose: () => void;
    onChange: any;
}

const DialogAddWalletAddress: FC<DialogAddWalletAddressProps> = ({
    open,
    value,
    title,
    subTitle,
    confirm,
    description,
    address,
    onClose,
    onChange
}) => {
    return (
        <Dialog
            open={open}
            keepMounted
            aria-describedby="dialog-slides"
            sx={{
                zIndex: 1301,
                "& .MuiDialog-paper": {
                    background: "var(--bg-dialog)",
                    borderRadius: "32px !important",
                    border: '1px solid var(--black)',
                    py: 5,
                    px: 4,
                    m: 2,
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    textAlign: "-webkit-center",
                    width: "440px !important",
                },
            }}
        >
            <Stack direction={'row'} gap={1} justifyContent={'center'}>
                <Typography fontSize={24} fontWeight={600}>{title}</Typography>
                <LinearTextDialog>{subTitle}</LinearTextDialog>
            </Stack>
            {description && <Typography fontSize={12} fontWeight={400}>{description}</Typography>}
            <Box mt={3} display={'flex'} alignItems={'center'} justifyContent={'center'}>
                <img src={IconAccountActive} alt="IconAccountActive" width={40} height={40} />
                <TextField
                    fullWidth
                    sx={{
                        ml: 1,
                        "& .MuiInputBase-input": {
                            padding: '10px 24px !important',
                            fontSize: '14px',
                            fontWeight: 400
                        },
                        "& .MuiOutlinedInput-root": {
                            borderRadius: '25px',
                            "&:hover": {
                                borderColor: 'unset',
                            },
                        }
                    }}
                    value={value}
                    onChange={(e: any) => onChange(e)}
                />
            </Box>
            <Stack direction={'row'} gap={1} justifyContent={'center'} mt={3}>
                <ContainButtonShort
                    onClick={confirm}
                    disabled={_.isEmpty(value)}
                >
                    Confirm
                </ContainButtonShort>
                <OutlineButtonShort onClick={onClose}>Cancel</OutlineButtonShort>
            </Stack>
        </Dialog>
    );
};

export default DialogAddWalletAddress;
